import type { IpdOrderPriority, IpdOrderState, IpdTaskDisplayStatus } from '@his/shared';
import { tr } from '@/lib/i18n-core';
import { cn } from '@/lib/utils';
import { Badge, StatusBadge } from '@/components/ui/primitives';
import { taskStatusLabel, taskStatusTone } from './task-labels';

export function TaskStatusChip({ status, label, className }: { status: IpdTaskDisplayStatus; label?: string; className?: string }) {
  return <StatusBadge status={status} tone={taskStatusTone(status)} label={label ?? taskStatusLabel(status)} className={cn('normal-case', className)} />;
}

export function OrderBadges({ priority, isHighAlert, state, className }: { priority: IpdOrderPriority; isHighAlert: boolean; state?: IpdOrderState; className?: string }) {
  const showState = state === 'held' || state === 'stopped' || state === 'completed';
  if (priority === 'routine' && !isHighAlert && !showState) return null;
  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1', className)}>
      {priority !== 'routine' && (
        <Badge variant={priority === 'stat' ? 'destructive' : 'warning'} className="px-1.5 py-0 text-[11px]">
          {tr('ipd', `io_priority_${priority}`)}
        </Badge>
      )}
      {isHighAlert && (
        <Badge variant="destructive" className="px-1.5 py-0 text-[11px]">
          {tr('ipd', 'io_task_high_alert')}
        </Badge>
      )}
      {showState && state && (
        <StatusBadge status={state} tone={state === 'held' ? 'warning' : 'muted'} label={tr('ipd', `io_state_${state}`)} className="normal-case px-1.5 py-0 text-[11px]" />
      )}
    </span>
  );
}
